import React, { useState } from "react";
import Rating from "react-rating";
import { Badge, Col, Container, Form, Row } from "react-bootstrap";

import { CiGrid41, CiHeart, CiViewList } from "react-icons/ci";
import {
  BsArrowLeftCircle,
  BsArrowRightCircle,
  BsGrid3X3Gap,
} from "react-icons/bs";
import { FaRegEye } from "react-icons/fa";
import { TbLoader3 } from "react-icons/tb";

const ProductList = ({themeColor}) => {
  const [viewStyle, setViewStyle] = useState("grid");
  const productlistData = [
    {
      id: 1,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Women Color block Sneakers",
      category: "Sneakers & Kids",
      price: "$80",
      oldPrice: "$120",
    },
    {
      id: 2,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Stylish Running Shoes",
      category: "Sports & Fitness",
      price: "$70",
      oldPrice: "$100",
    },
    {
      id: 3,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Comfortable Casual Sneakers",
      category: "Casual Wear",
      price: "$90",
      oldPrice: "$130",
    },
    {
      id: 4,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Trendy Outdoor Sneakers",
      category: "Outdoor Gear",
      price: "$85",
      oldPrice: "$125",
    },
    {
      id: 5,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Women Color block Sneakers",
      category: "Sneakers & Kids",
      price: "$80",
      oldPrice: "$120",
    },
    {
      id: 6,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Stylish Running Shoes",
      category: "Sports & Fitness",
      price: "$70",
      oldPrice: "$100",
    },
    {
      id: 7,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Comfortable Casual Sneakers",
      category: "Casual Wear",
      price: "$90",
      oldPrice: "$130",
    },
    {
      id: 8,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Trendy Outdoor Sneakers",
      category: "Outdoor Gear",
      price: "$85",
      oldPrice: "$125",
    },
    {
      id: 9,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Trendy Outdoor Sneakers",
      category: "Outdoor Gear",
      price: "$85",
      oldPrice: "$125",
    },
    {
      id: 10,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Trendy Outdoor Sneakers",
      category: "Outdoor Gear",
      price: "$85",
      oldPrice: "$125",
    },
    {
      id: 11,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Trendy Outdoor Sneakers",
      category: "Outdoor Gear",
      price: "$85",
      oldPrice: "$125",
    },
    {
      id: 12,
      img: `https://i.pravatar.cc/?img=1`,
      title: "Trendy Outdoor Sneakers",
      category: "Outdoor Gear",
      price: "$85",
      oldPrice: "$125",
    },
  ];

  return (
    <>
      <div className="hstack justify-content-between py-2 px-3 border-bottom">
        <Form.Label className="text-nowrap m-0">
          <b>Total Result -</b> 215
        </Form.Label>
        <Form.Group className="hstack gap-2">
          <Form.Label className="m-0 fw-bold text-nowrap">Sort By :</Form.Label>
          <Form.Select
            style={{ minWidth: "-webkit-fill-available", fontSize: 11 }}
          >
            <option value="popularity">Popularity</option>
            <option value="lowHigh">Low - High Price</option>
            <option value="highLow">High - Low Price</option>
            <option value="atoz">A - Z Order</option>
            <option value="ztoa">Z - A Order</option>
          </Form.Select>
        </Form.Group>
        <div className="hstack gap-2">
          <button
            className={`tabItem rounded-1 ${
              viewStyle === "list" && "tabItemActive"
            }`}
            onClick={() => setViewStyle("list")}
            title="Switch to list view"
          >
            <CiViewList style={{ fontSize: 15 }} />
          </button>
          <button
            className={`tabItem rounded-1 ${
              viewStyle === "grid" && "tabItemActive"
            }`}
            onClick={() => setViewStyle("grid")}
            title="Switch to grid view"
          >
            <BsGrid3X3Gap style={{ fontSize: 15 }} />
          </button>
          <button
            className={`tabItem rounded-1 ${
              viewStyle === "gridgap" && "tabItemActive"
            }`}
            onClick={() => setViewStyle("gridgap")}
            title="Switch to grid view"
          >
            <CiGrid41 style={{ fontSize: 15 }} />
          </button>
        </div>
      </div>
      {viewStyle === "list" ? (
        <Container>
          <Row>
            {productlistData?.map((product) => (
              <Form.Group
                as={Col}
                md={12}
                className="mt-2 mb-3"
                key={product.id}
              >
                <div className="position-relative shadow-sm p-3 d-flex gap-5 justify-content-between">
                  <div>
                    <div className="hstack justify-content-between">
                      <Badge className="bg-danger fs-11 br3">Sale</Badge>
                      <Form.Group className="CP" title="Add to wishlist">
                        <CiHeart style={{ fontSize: 15 }} />
                      </Form.Group>
                    </div>
                    <div
                      className="position-relative quickView CP"
                      title="Quick Access"
                    >
                      <img
                        src={product.img}
                        alt=""
                        style={{
                          height: 180,
                          width: 250,
                          objectFit: "contain",
                        }}
                      />
                      <div
                        className="position-absolute w-100 top-0 h-100 quickView_Icon"
                        style={{ backgroundColor: "#02454cb3" }}
                      >
                        <div className="w-100 h-100 position-absolute hstack justify-content-center text-center">
                          <FaRegEye style={{ fontSize: 15 }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-100 text-start">
                    <p className="m-0 text-muted fs-10">{product.category}</p>
                    <p className="mb-1 fw-bold lh-1 mb-2 fs-14">
                      {product.title}
                    </p>
                    <p className="m-0 fs-14">
                      <s className="text-danger me-1">{product.oldPrice}</s>
                      {product.price}
                    </p>
                    <Rating
                      className="text-warning"
                      style={{ fontSize: 6 }}
                      emptySymbol="fa fa-star-o fa-2x"
                      fullSymbol="fa fa-star fa-2x"
                    />
                  </div>
                  <div>
                    <button className="tabItem rounded-1 w-100 mb-3">
                      Add to cart
                    </button>
                    <button className="tabItem rounded-1 w-100">Buy Now</button>
                  </div>
                </div>
              </Form.Group>
            ))}
          </Row>
          <div className="hstack justify-content-between mb-3">
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              <BsArrowLeftCircle style={{ fontSize: 15 }} />
              previous
            </button>
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              <TbLoader3 style={{ fontSize: 15 }} />
              Load More
            </button>
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              Next
              <BsArrowRightCircle style={{ fontSize: 15 }} />
            </button>
          </div>
        </Container>
      ) : viewStyle === "grid" ? (
        <Container>
          <Row>
            {productlistData?.map((product) => (
              <Form.Group
                as={Col}
                key={product?.id}
                xl={3}
                lg={4}
                md={6}
                className="mt-2 mb-3"
              >
                <div
                  className="position-relative shadow-sm p-3 h-100 hstack justify-content-between"
                  style={{ flexDirection: "column" }}
                >
                  <div className="hstack justify-content-between">
                    <Badge className="br3 px-2 py-1" 
                      style={{
                        backgroundColor: themeColor,
                        fontSize: 11,
                      }}
                    >
                      Sale
                    </Badge>
                    <Form.Group className="CP" title="Add to wishlist">
                      <CiHeart style={{ fontSize: 25 }} />
                    </Form.Group>
                  </div>
                  <div
                    className="position-relative quickView CP"
                    title="Quick Access"
                  >
                    <img
                      src={product.img}
                      alt=""
                      style={{ height: 180, objectFit: "contain" }}
                    />
                    <div
                      className="position-absolute w-100 top-0 h-100 quickView_Icon"
                      style={{ backgroundColor: "#02454cb3" }}
                    >
                      <div className="w-100 h-100 position-absolute hstack justify-content-center text-center">
                        <FaRegEye
                          style={{ width: 25 }}
                          className="text-white"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-100 text-start">
                    <p className="m-0 text-muted fs-10">{product.category}</p>
                    <p className="mb-1 fw-bold lh-1 mb-2 fs-14">
                      {product.title}
                    </p>
                    <div className="hstack justify-content-between">
                      <p className="m-0 fs-14">
                        <s className="text-danger me-1">{product.oldPrice}</s>
                        {product.price}
                      </p>
                      <Rating
                        className="text-warning"
                        style={{ fontSize: 6 }}
                        emptySymbol="fa fa-star-o fa-2x"
                        fullSymbol="fa fa-star fa-2x"
                      />
                    </div>
                    <div className="hstack gap-2 justify-content-between mt-2">
                      <button className="tabItem rounded-1 w-100">
                        Add to cart
                      </button>
                      <button className="tabItem rounded-1 w-100">
                        Buy Now
                      </button>
                    </div>
                  </div>
                </div>
              </Form.Group>
            ))}
          </Row>
          <div className="hstack justify-content-between mb-3">
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              <BsArrowLeftCircle
                style={{ fontSize: 13, marginBottom: 2 }}
                className="me-1"
              />
              previous
            </button>
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              <TbLoader3
                style={{ fontSize: 13, marginBottom: 2 }}
                className="me-1"
              />
              Load More
            </button>
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              Next
              <BsArrowRightCircle
                style={{ fontSize: 13, marginBottom: 2 }}
                className="ms-1"
              />
            </button>
          </div>
        </Container>
      ) : viewStyle === "gridgap" ? (
        <Container>
          <Row>
            {productlistData?.map((product) => (
              <Form.Group
                as={Col}
                md={6}
                className="mt-2 mb-3"
                key={product.id}
              >
                <div className="position-relative shadow-sm p-3 d-flex gap-5 justify-content-between">
                  <div>
                    <div className="hstack justify-content-between">
                      <Badge className="bg-danger fs-11 br3">Sale</Badge>
                      <Form.Group className="CP" title="Add to wishlist">
                        <CiHeart style={{ fontSize: 25 }} />
                      </Form.Group>
                    </div>
                    <div
                      className="position-relative quickView CP"
                      title="Quick Access"
                    >
                      <img
                        src={product.img}
                        alt=""
                        style={{
                          height: 180,
                          width: 200,
                          objectFit: "contain",
                        }}
                      />
                      <div
                        className="position-absolute w-100 top-0 h-100 quickView_Icon"
                        style={{ backgroundColor: "#02454cb3" }}
                      >
                        <div className="w-100 h-100 position-absolute hstack justify-content-center text-center">
                          <FaRegEye
                            style={{ width: 25 }}
                            className="text-white"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="hstack justify-content-between w-100 text-start"
                    style={{ flexDirection: "column" }}
                  >
                    <div className="w-100 ">
                      <p className="m-0 text-muted fs-10">{product.category}</p>
                      <p className="mb-1 fw-bold lh-1 mb-2 fs-14">
                        {product.title}
                      </p>
                      <p className="m-0 fs-14">
                        <s className="text-danger me-1">{product.oldPrice}</s>
                        {product.price}
                      </p>
                      <Rating
                        className="text-warning"
                        style={{ fontSize: 6 }}
                        emptySymbol="fa fa-star-o fa-2x"
                        fullSymbol="fa fa-star fa-2x"
                      />
                    </div>
                    <div className="w-100">
                      <button className="tabItem rounded-1 w-100 mb-1">
                        Add to cart
                      </button>
                      <button className="tabItem rounded-1 w-100">
                        Buy Now
                      </button>
                    </div>
                  </div>
                </div>
              </Form.Group>
            ))}
          </Row>
          <div className="hstack justify-content-between mb-3">
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              <BsArrowLeftCircle
                style={{ fontSize: 13, marginBottom: 2 }}
                className="me-1"
              />
              previous
            </button>
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              <TbLoader3
                style={{ fontSize: 13, marginBottom: 2 }}
                className="me-1"
              />
              Load More
            </button>
            <button className="tabItem rounded-1" style={{ minWidth: 100 }}>
              Next
              <BsArrowRightCircle
                style={{ fontSize: 13, marginBottom: 2 }}
                className="ms-1"
              />
            </button>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
};

export default ProductList;
